<template>
  <svg
    width="358"
    height="308"
    viewBox="0 0 358 308"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <text
      fill="url(#paint0_linear_1844_2281)"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="28"
      font-weight="bold"
      letter-spacing="-0.01em"
    >
      <tspan x="44.7225" y="27.1818">Bitcoin&#39;s UTXO Data</tspan>
      <tspan x="9.35609" y="61.1818">Consensus Protocol is an</tspan>
      <tspan x="17.4023" y="95.1818">open and decentralized&#13;</tspan>
      <tspan x="59.1091" y="129.182">hybrid consensus</tspan>
      <tspan x="100.755" y="163.182">mechanism</tspan>
    </text>
    <text
      fill="#8C8C8C"
      xml:space="default"
      font-family="Inter"
      font-size="12"
      letter-spacing="0em"
    >
      <tspan x="24.002" y="199.364">Bitcoin&#39;s metadata sync protocol merges PoW and PoS</tspan>
      <tspan x="18.2891" y="217.364">
        consensus to ensure accurate synchronization, with fully
      </tspan>
      <tspan x="29.6211" y="235.364">open-source code and data for community audit and</tspan>
      <tspan x="145.965" y="253.364">verification.</tspan>
    </text>
    <path
      d="M113 286C113 279.373 118.373 274 125 274H233C239.627 274 245 279.373 245 286V296C245 302.627 239.627 308 233 308H125C118.373 308 113 302.627 113 296V286Z"
      fill="#F0F0F0"
      @click="handleClick"
    />
    <text
      fill="#1F1F1F"
      xml:space="preserve"
      style="white-space: pre"
      font-family="Inter"
      font-size="12"
      font-weight="600"
      letter-spacing="0em"
      @click="handleClick"
    >
      <tspan x="129" y="295.364">Protocol Explorer</tspan>
    </text>
    <defs>
      <linearGradient
        id="paint0_linear_1844_2281"
        x1="179"
        y1="0"
        x2="-45.551"
        y2="161.545"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="#999999" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup>
const handleClick = () => {
  window.open('https://utxoverse.xyz/dashboard', '_blank')
}
</script>

<style scoped></style>
